// Port of api/fuel/app/classes/insights/game/recent.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'recent',
    priority: 8,
    enabled: false,
    requires: ['init'],
    insight: false,
    types: [Constants.TYPE_USER],
    run: function(type, owner, userIndex, detail, filter, vars) {

        if (!this._data.has_plays) return {}

        var user_id = owner.get_id()
        var playsRaw = this._data.plays_raw
        var playersRaw = this._data.players_raw

        var limit = detail ? 250 : 5

        // Index players by play_id
        var playersByPlay = {}
        for (var pi = 0; pi < playersRaw.length; pi++) {
            var playId = parseInt(playersRaw[pi].play_id, 10)
            if (!playersByPlay[playId]) playersByPlay[playId] = []
            playersByPlay[playId].push(playersRaw[pi])
        }

        // Plays sorted by date ascending, reverse for most recent first
        var plays = playsRaw.slice().reverse()
        var total = plays.length
        var list = []

        var sliced = plays.slice(0, limit)
        for (var i = 0; i < sliced.length; i++) {
            var play = sliced[i]
            var pId = parseInt(play.play_id, 10)
            var players = []

            if (playersByPlay[pId]) {
                for (var j = 0; j < playersByPlay[pId].length; j++) {
                    var p = playersByPlay[pId][j]
                    var pUserId = parseInt(p.user_id, 10) || 0

                    if (pUserId === user_id) continue

                    players.push({
                        name: p.player_name,
                        username: p.player_username || null,
                        slug: p.player_username || p.player_name
                    })

                    if (pUserId) this._references.users.push(pUserId)
                }
            }

            list.push({
                date: parseInt(play.play_date, 10) || 0,
                players: players
            })
        }

        return {
            recent: {
                list: list,
                total: total
            }
        }

    }
})
